import { sdkLogger } from '../../logger/logger';
import { toSdkLoggableError } from '../../types/shared';
import { buildMarkAsStartedUrl } from './url';

/**
 * Fire-and-forget GET to mark the survey response instance as started.
 */
export async function markResponseInstanceAsStarted(instanceId: string): Promise<boolean> {
  const url = buildMarkAsStartedUrl(instanceId);

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) {
      sdkLogger.warn(`markResponseInstanceAsStarted failed (${response.status})`, { url });
      return false;
    }

    const data = await response.json().catch(() => null);
    const success = data === true;
    if (success) {
      sdkLogger.info('Survey response instance marked as started', { instanceId });
    }
    return success;
  } catch (err) {
    sdkLogger.warn('markResponseInstanceAsStarted request failed', { err: toSdkLoggableError(err) });
    return false;
  }
}
